<template>
  <div class="contents-area">
    <PriceActiveTabs :activeTab="activeCategory" @changeActiveTab="changeActiveTab" />
    <div class="price-list">
      <PriceBookList :priceBookList="priceList" />
    </div>
  </div>
</template>

<script>
import PriceActiveTabs from "./parts/PriceCategoryTabs.vue";
import PriceBookList from "./parts/PriceBookList.vue";
export default {
  data() {
    return {
      activeCategory: 0,
      priceInfo: {}
    };
  },
  components: {
    PriceActiveTabs,
    PriceBookList
  },
  computed: {
    priceList() {
      if (this.activeCategory === 0) {
        return this.priceInfo.book_price_list;
      } else if (this.activeCategory === 1) {
        return this.priceInfo.subscribes_price_list;
      } else if (this.activeCategory === 2) {
        return this.priceInfo.school_price_list;
      } else {
        return this.priceInfo.original_price_list;
      }
    }
  },
  created() {
    this.loadContents();
  },
  methods: {
    loadContents() {
      this.$store.dispatch("getPriceList").then(res => {
        this.priceInfo = res;
      });
    },
    changeActiveTab(activeTab) {
      this.activeCategory = activeTab;
    }
  }
};
</script>

<style lang="scss" scoped>
.price-list {
  padding-top: 50px;
  max-width: 800px;
  margin: auto;
  @media screen and (max-width: 650px) {
    padding-top: 80px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/priceList/Home.vue